<template>
    <nio-modal
        name="confirm"
        size="sm"
        :title="title"
        ref="modal"
        @close="close"
        @opened="onOpened"
    >
        <div>
            <slot name="message" />
        </div>

        <template #footer>
            <nio-button ref="deny" @click="onDeny">
                <slot name="deny">
                    {{ $t('global.confirmModal.no') }}
                </slot>
            </nio-button>
            <nio-button color="blue" @click="onApprove">
                <slot name="confirm">
                    {{ $t('global.confirmModal.yes') }}
                </slot>
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    export default {
        props: {
            opened: {
                type: Boolean,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
        },

        watch: {
            opened(isOpened) {
                if (isOpened) {
                    this.$refs.modal.open();
                } else {
                    this.$refs.modal.close();
                }
            },
        },

        methods: {
            onApprove() {
                this.close();

                this.$nextTick(() => {
                    this.$emit('confirm');
                });
            },

            onDeny() {
                this.close();

                this.$nextTick(() => {
                    this.$emit('deny');
                });
            },

            onOpened() {
                this.$refs.deny.focus();
            },

            close() {
                this.$emit('update:opened', false);
            },
        },
    };
</script>
